import { ERP } from '../_base/endpoint';
import global from '../../common/utility/global';
import axios from 'axios';

class compraProductoService {
    
    /******* QUERIES ******/

    async paginacion(filter) {
        const response = await axios
            .get(`${ERP}logistica/compra-producto/paginacion?${global.formatParameter(filter)}`)
            .then(response => { 
                return response.data; 
            })
            .catch(error => {
                console.log(error);
            });
        return response;
    };

    async excel(filter) {
        const response = await axios
            .get(`${ERP}logistica/compra-producto/excel?${global.formatParameter(filter)}`, { responseType: 'blob', })
            .then(response => {
                return response;
            })
            .catch(error => {
                console.log(error);
            });
        return response;
    };

    async pdf(filter) {
        const response = await axios
            .get(`${ERP}logistica/compra-producto/pdf?${global.formatParameter(filter)}`, { responseType: 'blob', })
            .then(response => {
                return response;
            })
            .catch(error => {
                console.log(error);
            });
        return response;
    };

    /******* TRANSACCIONES ******/
}

export default new compraProductoService();